import RaisedButton from 'material-ui/RaisedButton';
import React, { Component } from 'react';
import { connect } from "react-redux";
import LeftLink from '../leftlink/leftlink.jsx';
import AuthNavbar from '../navigation/authnavigation.jsx';

const mapStateToProps = state =>
    ({
        rowData: state.storeRowDetail.rowData
    })
const mapDispatchToProps = dispatch =>
    ({

    })

class ViewTransferHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            historyType: '',
            statementFromDate: '',
            statementTodDate: '',
            status: '',
        }
    }

    handeltransfer(e){
        this.props.history.push("/transfer-history")
    }
    render() {
        const { rowData } = this.props
      
        return (
            <div>
                <div className="row">
                    <div className="col-sm-12">
                        <AuthNavbar />
                    </div>

                </div>
                <div className="container" style={{ marginTop: "80px" }}>
                    <div className="row">
                        <div className="col-sm-3 box-shadow-style nopadding" style={{ minHeight: "470px" }}>
                            <LeftLink />
                        </div>
                        <div className="col-sm-9" style={{ padding: "0px 30px" }}>
                            <div className="row box-shadow-style" style={{ padding: "12px 0px", minHeight: "476px" }}>
                                <div className="col-sm-11">
                                    <div className="row">
                                        <div className="col-sm-12 header-style">
                                            <h5>
                                                Share Funds - View
                                            </h5>
                                        </div>
                                        
                                        <div className="col-sm-12 " style={{ fontSize: "14px" }} >
                                        <div className="tile box-shadow-style">
                                        <div className="col-sm-4 nopadding" >
                                                <h5>Transfer Details</h5>
                                            </div>
                                            <div className="col-sm-12" >
                                            <div className="row" style={{ marginTop: "10px" }}>
                                            
                                                <div className=" col-sm-4  tilepadding">
                                                    <label className="tilecontent"> Transfer ID  </label>
                                                </div>
                                                <div className="col-md-6 text-left tilepadding">
                                                    <span className="tileheadername">:   {rowData.transactionId}  </span><br />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className=" col-md-4  tilepadding">
                                                    <label className="tilecontent">Status </label>
                                                </div>
                                                <div className="col-md-7 text-left tilepadding">
                                                    <span className="tileheadername">:   {rowData.status} </span><br />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className=" col-md-4  tilepadding">
                                                    <label className="tilecontent">Card Account (From)  </label>
                                                </div>
                                                <div className="col-md-7 text-left tilepadding">
                                                    <span className="tileheadername">:   {rowData.cardProgramId} : {rowData.fromaccountNumber} :  {rowData.balance} </span><br />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4  tilepadding">
                                                    <label className="tilecontent">Card Account (To)  </label>
                                                </div>
                                                <div className="col-md-7 text-left tilepadding">
                                                    <span className="tileheadername">:    </span><br />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4  tilepadding">
                                                    <label className="tilecontent">Debit Amount </label>
                                                </div>
                                                <div className="col-md-7 text-left tilepadding">
                                                    <span className="tileheadername">:  {rowData.amount}  </span><br />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4  tilepadding">
                                                    <label className="tilecontent">Transfer Date  </label>
                                                </div>
                                                <div className="col-md-7 text-left tilepadding">
                                                    <span className="tileheadername">:   {rowData.transferDate} </span><br />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4  tilepadding">
                                                    <label className="tilecontent">Comments  </label>
                                                </div>
                                                <div className="col-md-7 text-left tilepadding">
                                                    <span className="tileheadername">:   {rowData.comments}  </span><br />
                                                </div>
                                            </div>
                                            <div className=" offset-sm-2 col-sm-2" >
                                                <RaisedButton
                                                     className="btn-std"
                                                     backgroundColor="#FFCE39"
                                                     labelColor="#115876"
                                                   
                                                    onClick={this.handeltransfer.bind(this)}
                                                    style={{ marginTop: "10px" }}
                                                />
                                            </div>
                                        </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}
ViewTransferHistory.defaultProps = {
    cardState: {
        status: 600
    },
    transHistory: {
        status: 600
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewTransferHistory);



// WEBPACK FOOTER //
// ./src/components/transferfunds/viewtransferhistory.jsx